import type { ReactNode } from 'react';

import { Contexto } from './primitivas';
import type { AneryChip } from './tiposDaEsteira';
import { variaveisDaMarca } from '../../tema/variaveisDaMarca';

/**
 * Casca das telas portadas do protótipo — ADR-0005.
 *
 * Carrega as variáveis da marca e o cabeçalho. O `h1` é o motivo de existir:
 * a captação nasceu sem nenhum, e tela sem título não se anuncia a leitor de
 * tela nem a quem chega pelo endereço direto.
 */
export function TelaAnery({
  breadcrumb,
  titulo,
  subtitulo,
  chips,
  children,
}: {
  breadcrumb: string;
  titulo: string;
  subtitulo?: string;
  chips?: AneryChip[];
  children: ReactNode;
}): React.JSX.Element {
  return (
    <div className="anery-marca" style={variaveisDaMarca}>
      <p className="cond text-[0.6875rem] uppercase tracking-[0.12em] text-[var(--tinta-3)]">
        {breadcrumb}
      </p>
      <h1 className="mt-1 text-[1.375rem] font-semibold leading-tight text-[var(--navy)]">
        {titulo}
      </h1>
      {subtitulo && (
        <p className="mt-2 max-w-[68ch] text-[0.875rem] leading-relaxed text-[var(--tinta-2)]">
          {subtitulo}
        </p>
      )}
      <Contexto chips={chips} />
      {children}
    </div>
  );
}
